import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';

import { CARD_IMAGE_MAX_SIZE, CARD_IMAGE_TYPE } from 'common/constants/files';
import { IMAGE_VARIANTS } from 'common/constants/image';
import { EImageVariant } from 'common/types';
import { ImageField } from 'common/components/FormField';
import { FormSection } from 'common/components/FormSection';
import { Img } from 'common/components/Img';
import { Banner } from 'common/components/Banner';
import LibraryImage from 'assets/images/library.webp';

export const LibraryOverviewImageFormSection = () => {
    const [translate] = useTranslation();
    const smallScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.only('xs')
    );

    return (
        <FormSection
            description={translate('libraryForm.imageDescription')}
            title={translate('image')}
        >
            <Stack
                direction={smallScreen ? 'column-reverse' : 'row'}
                spacing={2}
                sx={{ mt: 2 }}
            >
                <Box sx={{ width: '100%' }}>
                    <Field
                        acceptedFileTypes={CARD_IMAGE_TYPE}
                        component={ImageField}
                        helperText={translate('imageSizeDescription', {
                            width: IMAGE_VARIANTS[EImageVariant.Card].minWidth,
                            height: IMAGE_VARIANTS[EImageVariant.Card]
                                .minHeight,
                        })}
                        imageVariant={EImageVariant.Card}
                        label={translate('libraryForm.overviewImage')}
                        maxUploadSize={CARD_IMAGE_MAX_SIZE}
                        name="thumbnail"
                    />
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Banner>
                        <Box sx={{ py: 1, pr: 1, pl: 2 }}>
                            {translate(
                                'libraryForm.imageInOverviewsDescription'
                            )}
                        </Box>
                        <Box sx={{ mt: 'auto' }}>
                            <Img src={LibraryImage} />
                        </Box>
                    </Banner>
                </Box>
            </Stack>
        </FormSection>
    );
};
